import { on, off } from 'helpers/dom'
import { useState, useEffect } from 'preact/hooks'
import { detectBreakpoint } from 'helpers/breakpoint'
import throttle from 'lodash.throttle'

const useDetectBreakpoint = () => {
  const [breakpoints, setBreakpoints] = useState({
    isMobile: detectBreakpoint(''),
    isTablet: detectBreakpoint('tablet'),
    isDesktop: detectBreakpoint('desktop'),
    isDesktopLarge: detectBreakpoint('desktop-large'),
    isLarge: detectBreakpoint('large')
  })

  const onResize = throttle(() => {
    const currentWidth = window.innerWidth

    setBreakpoints({
      isMobile: detectBreakpoint('', currentWidth),
      isTablet: detectBreakpoint('tablet', currentWidth),
      isDesktop: detectBreakpoint('desktop', currentWidth),
      isDesktopLarge: detectBreakpoint('desktop-large', currentWidth),
      isLarge: detectBreakpoint('large', currentWidth)
    })
  }, 400)

  useEffect(() => {
    on('resize', onResize, window)

    return () => off('resize', onResize, window)
  }, [])

  return breakpoints
}

export default useDetectBreakpoint
